module.exports = __webpack_public_path__ + "img/setting-manage.1cb76747.svg";